import { render, staticRenderFns } from "./callback_twitter.vue?vue&type=template&id=073db1da&scoped=true"
import script from "./callback_twitter.vue?vue&type=script&lang=js"
export * from "./callback_twitter.vue?vue&type=script&lang=js"
import style0 from "./callback_twitter.vue?vue&type=style&index=0&id=073db1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073db1da",
  null
  
)

export default component.exports